var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 428 524",
    style: {
      enableBackground: "new 0 0 428 524"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ffffff;stroke-width:0;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,7c34.9,0,63.2,28.4,63.2,63.2s-28.4,63.2-63.2,63.2s-63.2-28.4-63.2-63.2S69.3,7,104.1,7 M151.6,149.3  h-11.2c-22.4,10.3-49.1,10.8-72.4,0H56.8c-26.2,0-47.5,21.3-47.5,47.5v134.4c0,13,10.6,23.7,23.7,23.7h15.9v134.4  c0,13,10.6,23.7,23.7,23.7h63.2c13,0,23.7-10.6,23.7-23.7V354.9h15.9c13,0,23.7-10.6,23.7-23.7V196.8  C199.1,170.6,177.9,149.3,151.6,149.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.1,7c34.9,0,63.2,28.4,63.2,63.2s-28.4,63.2-63.2,63.2s-63.2-28.4-63.2-63.2S276.3,7,311.1,7 M358.6,149.3  h-11.2c-22.4,10.3-49.1,10.8-72.4,0h-11.2c-26.2,0-47.5,21.3-47.5,47.5v134.4c0,13,10.6,23.7,23.7,23.7h15.9v134.4  c0,13,10.6,23.7,23.7,23.7h63.2c13,0,23.7-10.6,23.7-23.7V354.9h15.9c13,0,23.7-10.6,23.7-23.7V196.8  C406.1,170.6,384.9,149.3,358.6,149.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2);
export default __webpack_public_path__ + "static/media/h2.4cda33a889d1d7e0872f1594a3b8dc68.svg";
export { ForwardRef as ReactComponent };